module.exports = __webpack_public_path__ + "img/share-btn-right.7d10adb6.png";